import { render, staticRenderFns } from "./noBorderTableCont.vue?vue&type=template&id=25a069bf"
import script from "./noBorderTableCont.vue?vue&type=script&lang=js"
export * from "./noBorderTableCont.vue?vue&type=script&lang=js"
import style0 from "./noBorderTableCont.vue?vue&type=style&index=0&id=25a069bf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports